import MapServiceIcon from './component'

export default MapServiceIcon
